module.exports = __webpack_public_path__ + "img/page_1_4.f46ae41a.png";